import { xovisPutRequest } from '../../../../../api/xovis/xovis.api';

/**
 * Обновление connection для выгрузки
 * @param {object} sensor объект сенсора
 * @param {object} payload Тело запроса
 * @param {number} connectionId ID connection
 * @returns Объект с ошибкой или нового агента
 */
const updateXovisConnectionV5 = async (args) => {
    const { sensor, payload, connectionId } = args;

    const updatedConnection = await xovisPutRequest({
        url: `http://${sensor.ip}:${sensor.port}/api/v5/${
            sensor.isMultiSensor ? 'multisensor' : 'singlesensor'
        }/data/push/connections/${connectionId}`,
        body: payload,
        username: sensor.username,
        password: sensor.password,
    });

    if (!updatedConnection.error) {
        return updatedConnection;
    }

    return { error: 'Ann error accrued while update connection' };
};

export default updateXovisConnectionV5;
